import { Feature } from 'ol';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { LAYER_TYPE } from '@/components/Map/MapViewer/MapViewer.constants';

/**
 * Wraps a process-layer {@link VectorSource} in a fresh {@link VectorLayer}.
 *
 * A single OpenLayers layer object cannot belong to more than one map, but a
 * source can be shared. Each map that needs to render the process features
 * builds its own layer over the shared source via this factory.
 */
export const createProcessLayer = (
  source: VectorSource<Feature>,
): VectorLayer<VectorSource<Feature>> => {
  const vectorLayer = new VectorLayer({
    zIndex: 0,
    source,
    updateWhileAnimating: true,
    updateWhileInteracting: true,
  });
  vectorLayer.set('type', LAYER_TYPE.PROCESS_LAYER);
  return vectorLayer;
};
